import { List, Map, OrderedMap } from 'immutable';

import * as types from './types';
import { types as activityTypes, utils } from './../activity';

const initialState = Map({
  count: 0,
  loading: true,
  results: OrderedMap(),
  selectedGroups: List(),
  autocompletedGroups: List(),
});

const groupsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case types.GROUP_LIST_GET.SUCCESS: {
      return state.withMutations((mutable) => {
        const groups = payload.results.reduce((acc, group) => {
          acc[group.id] = group;
          return acc;
        }, {});
        mutable.set('loading', false);
        mutable.set('count', payload.count);
        mutable.set('results', OrderedMap(groups));
      });
    }
    case types.TOGGLE_GROUP_SELECTION: {
      const selectedGroups = state.get('selectedGroups');
      const index = selectedGroups.indexOf(payload);

      if (index >= 0) {
        return state.deleteIn(['selectedGroups', index]);
      }

      return state.set('selectedGroups', selectedGroups.push(payload));
    }
    case types.TOGGLE_ALL_GROUPS_SELECTION: {
      const newSelection = payload.checked ? state.get('results').keySeq() : [];
      return state.set('selectedGroups', List(newSelection));
    }
    case types.GROUP_CREATE.SUCCESS: {
      return state.withMutations((mutable) => (
        mutable
          .set('count', state.get('count') + 1)
          .setIn(['results', payload.id], {
            ...payload,
            team_count: 0,
            user_count: 0,
            virtual_machines_last_concurrency: null,
          })
      ));
    }
    case types.GROUP_REMOVE.SUCCESS: {
      const index = state.get('selectedGroups').indexOf(payload);

      return state.withMutations((mutable) => {
        mutable
          .set('count', state.get('count') - 1)
          .deleteIn(['results', payload]);
        if (index >= 0) {
          mutable.deleteIn(['selectedGroups', index]);
        }
        return mutable;
      });
    }
    case activityTypes.GET_GROUPS_ACTIVITY.SUCCESS: {
      const results = state.get('results');
      const serializedEntries = utils.serializeTabularData(Object.entries(payload));

      return state.withMutations((mutable) => {
        serializedEntries
          .filter(([groupId]) => results.has(groupId))
          .forEach(([groupId, activity]) => {
            mutable.updateIn(
              ['results', groupId],
              (group) => ({ ...group, ...activity }),
            );
          });
      });
    }
    case types.AUTOCOMPLETE_GROUPS_GET.SUCCESS:
      return state.set('autocompletedGroups', List(payload.results));
    default:
      return state;
  }
};

export default groupsReducer;
